import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0309 from "../lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "14a09edf-b38c-42b0-b3fc-b27d388a495f",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0309),
    lesson: lesson0309,
  },
];

export default lessonLinks;
